import { ENTERPRISE, PAY_AS_YOU_GO } from 'Types/plan';
import { observer } from 'mobx-react-lite';
import { useEffect, useRef } from 'react';

import { useStore } from 'App/mstore';

// our own tenant never gets the survey
const OWN_TENANT_ID = 115;

/** Delighted NPS survey for paying accounts; renders nothing. */
function Survey() {
  const { userStore } = useStore();
  const { account } = userStore;
  const planType = account.plan?.type;
  const isPaidPlan = planType === ENTERPRISE || planType === PAY_AS_YOU_GO;
  const asked = useRef(false);

  useEffect(() => {
    const { delighted } = window as any;
    if (
      asked.current ||
      !delighted ||
      !isPaidPlan ||
      Number(account.tenantId) === OWN_TENANT_ID
    ) {
      return;
    }
    // once per load, even if the plan changes later in the session
    asked.current = true;
    setTimeout(() => {
      delighted.survey({
        email: account.email,
        name: account.name,
        properties: { plan: planType },
      });
    }, 1000);
    // /account can land after the shell mounts
  }, [account.id, isPaidPlan]);

  return null;
}

export default observer(Survey);
